export class CustomFile
{
    public name: string;
    public data: any;
    public type: string;
}
